import Flux from 'lib/flux';

const MessageConstants = Flux.createConstants({
  serviceMessages: ['SEND_MESSAGE'],
});

export default MessageConstants;
